import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from 'react'
import './declaredType.scss'

export default forwardRef((props, ref) => {
  const [declaredType, setDeclaredType] = useState('Active', 'Inactive')

  useImperativeHandle(ref, () => {
    return {
      doesFilterPass(params) {
        return params.data.declaredType !== 'Active'
      },

      isFilterActive() {
        return declaredType === 'Active'
      },
    }
  })

  const onTypeChange = (e) => {
    setDeclaredType(e.target.value)
  }

  useEffect(() => {
    props.filterChangedCallback()
  }, [declaredType])

  return (
    <div
      style={{
        // display: 'inline',
        width: '143px',
        height: '92px',
        borderRadius: '10',
      }}
    >
      <label
        style={{
          margin: '6px',
          padding: '10px',
          display: 'flex',
          backgroundColor: 'white',
          font: 'normal 18px/16px Poppins',
        }}
      >
        <input
          style={{
            marginRight: '4px',
            marginBottom: '5px',
            font: 'Poppins',
            
          }}
          type="checkbox"
          name="declaredType"
          value="Active"
          checked={declaredType === 'Active'}
          onChange={onTypeChange}
        />

        Active
      </label>
      <label
        style={{
          margin: '6px',
          padding: '10px',
          display: 'flex',
          backgroundColor: 'white',
          font: 'normal 18px/16px Poppins',
        }}
      >
        <input
          style={{
            marginRight: '7px',
            marginBottom: '5px',
            font: 'Poppins',
          }}
          className="inputCheckbox2"
          type="checkbox"
          name="declaredType"
          value="Inactive"
          checked={declaredType === 'Inactive'}
          onChange={onTypeChange}
        />
        Inactive
      </label>
    </div>
  )
})
